import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Dollar({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M12 7.49999V8.49999M12 16.5V15.5M9.85 14.25H9.849C10.239 15.06 11.089 15.55 11.989 15.5C13.079 15.62 14.079 14.84 14.239 13.75C14.239 12.99 13.699 12.34 12.959 12.19L10.999 11.79C10.249 11.64 9.719 10.99 9.719 10.23C9.869 9.12999 10.869 8.34999 11.969 8.47999C12.869 8.41999 13.709 8.90999 14.109 9.72999M12 2.48999C9.48044 2.48999 7.06408 3.49088 5.28249 5.27248C3.50089 7.05407 2.5 9.47043 2.5 11.99C2.5 14.5095 3.50089 16.9259 5.28249 18.7075C7.06408 20.4891 9.48044 21.49 12 21.49C13.2476 21.49 14.4829 21.2443 15.6355 20.7668C16.7881 20.2894 17.8354 19.5897 18.7175 18.7075C19.5997 17.8253 20.2994 16.7781 20.7769 15.6255C21.2543 14.4729 21.5 13.2375 21.5 11.99C21.5 10.7424 21.2543 9.50709 20.7769 8.3545C20.2994 7.2019 19.5997 6.15463 18.7175 5.27248C17.8354 4.39032 16.7881 3.69055 15.6355 3.21313C14.4829 2.73571 13.2476 2.48999 12 2.48999Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Dollar;